import React, { useState } from 'react'
import Modal from '../../../components/Modal'
import NewModal from '../../../components/NewModal/NewModal'
import Form from '../../../components/Form/Form'
import { useForm } from 'react-hook-form'
import FormAttention from '../../../components/FormAttention'
import FormInput from '../../../components/Inputs/FormInput/FormInput'
import { useHistory, useParams } from 'react-router-dom'
import { useHttp } from '../../../hooks/http.hook'
import { General_API } from '../General_API'
import AttentionGenerator from '../../../components/Form/AttentionGenerator'
import PasswordInput from '../../../components/PasswordInput'

function PasswordRestoreStep2(props) {
  const { request } = useHttp()
  const { register, errors, handleSubmit, watch, unregister, setError } = useForm()
  const history = useHistory()
  const { passwordRestoreStep2 } = General_API.passwordRestore
  const [requestResponse, setRequestResponse] = useState({})
  const { email, type, token } = useParams()

  const restoreWithEmail = async (form) => {
    const preparedForm = { ...form, type: type, token, email }
    setRequestResponse(await request(process.env.REACT_APP_BASE_URL + passwordRestoreStep2().api, passwordRestoreStep2().method, preparedForm, {}))
  }


  return (
      <Modal styles={{ top: '0' }}>
        <NewModal
            completed={requestResponse?.data?.message === 'ok'}
            title={'Восстановление пароля'}
            completedText={`Вы успешно сменили пароль.`}
            hideErrors
            completedButtonText={'Вернуться'}
            closeHandler={() => history.push(process.env.REACT_APP_URL_PREFIX)}
            hideCloseButton
        >
          <AttentionGenerator errors={{
            ...errors,
            error: { message: requestResponse.status !== 200 && requestResponse?.data?.message !== 'ok' ? requestResponse?.data?.message : '' },
            error2: { message: requestResponse.status === 200 && requestResponse?.data[1]?.message !== 'ok' ? requestResponse?.data?.message : '' }
          }} />

          <Form submitButtonText={'Продолжить'} submitHandler={handleSubmit(restoreWithEmail)}>



            <PasswordInput reff={register} />
            <FormInput name={'retryPassword'}
                       reff={register({ validate: { like: (value) => watch('password') !== value ? 'Пароли должны совпадать' : true } })}
                       hideIcon
                       title={'Повторите пароль'} type='password' />
          </Form>
        </NewModal>
      </Modal>
  )
}

export default PasswordRestoreStep2
